<template>

  <div name="modal">
    <div id="loading" :class="{'blocking':blocking}" v-if="loading && show" @click="onClick" :style="{backgroundColor : color}">
      <img :src="loading_img">
      <p v-if="message != ''" v-html="message"></p>
    </div>
    <div id="overlay" :class="{'blocking':blocking}" v-else-if="show" @click="onClick" :style="{backgroundColor : color}"></div>
  </div>

</template>

<script>
import store from '@/store'

export default {
  data () {
    return {
      show: false,
      closable: true,
      loading: false,
      loading_img: 'img/loader_light.svg',
      color: '000000cc',
      message: '',
      blocking: false,
      callClick: function () {}
    }
  },
  methods: {

    onClick (event) {
      if (typeof this.callClick !== 'undefined') {
        this.callClick(this, store)
      } else {
        if (!this.closable) {
          return
        }
        this.show = false
        document.body.style.overflow = 'auto'
      }
    }

  }
}
</script>

<style lang="scss">
    #overlay {
        background-color: rgba(0, 0, 0, 0.7);
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: $z-overlay-default;

        &.blocking {
          z-index: $z-overlay-blocking;
        }
    }

    #loading {
        background-color: rgba(0, 0, 0, 0.8);
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: $z-overlay-default + 1;

        &.blocking {
          z-index: $z-overlay-blocking + 10;
        }

        img {
          position: fixed;
          width: 200px;
          height: 100px;
          top: 50%;
          left: 50%;
          margin-top: -50px; /* Negative half of height. */
          margin-left: -100px; /* Negative half of width. */
        }
        p {
          position: fixed;
          width: calc( 100% - 50px );
          height: auto;
          top: calc( 50% + 120px );
          left: 50px;
          margin-top: -50px; /* Negative half of height. */
          color: rgba(255,255,255, 0.8);
          text-align: center;
          padding-right: 50px;
          @include font-size(24px);
          font-family: $conden-light;
        }
    }
</style>
